const newLang = {
  "problem":[
    {
      "id": 1,
      "en": "Who is your best friend?",
      "zh": "您小时候最好的朋友是？",
      "tw": "您小時候最好的朋友是？",
      "jp": "あなたの親友は誰ですか？",
      "es": "¿Quién es tu mejor amigo(amiga)?",
      "th": "ใครคือเพื่อนที่ดีที่สุดของคุณ?",
      "vn": "Ai là người bạn thân nhất của bạn?",
      "de": "Was war dein bester Freund, als du ein Kind warst?",
      "kr": "어렸을 때 가장 친했던 친구는?",
      "fr": "Quel était votre meilleur ami quand vous étiez enfant?",
    },
    {
      "id": 2,
      "en": "Who is your idol?",
      "zh": "您的偶像是？",
      "tw": "您的偶像是？",
      "jp": "あなたのアイドルは誰ですか？",
      "es": "¿Quien es tu idolo?",
      "th": "ไอดอลของคุณคือใคร?",
      "vn": "Thần tượng của bạn là ai?",
      "de": "Wer ist dein Idol?",
      "kr": "당신의 우상은 누구입니까?",
      "fr": "Qui est ton idole?",
    },
    {
      "id": 3,
      "en": "Where is your most yearning place?",
      "zh": "您最向往的地方是哪里？",
      "tw": "您最向往的地方是哪裏？",
      "jp": "あなたの最も憧れの場所はどこですか？",
      "es": "¿Dónde está tu lugar más anhelado?",
      "th": "ที่ไหนที่คุณโหยหามากที่สุด?",
      "vn": "Nơi khao khát nhất của bạn là ở đâu?",
      "de": "Wo ist dein sehnsüchtigster Ort?",
      "kr": "가장 그리운 곳은 어디인가요?",
      "fr": "Où est votre endroit le plus ardent?",
    },
  ]
}
export {newLang}



// WEBPACK FOOTER //
// ./src/utils/problem.js